import React, { useEffect, useState } from "react";

const DEFAULT_FORM = {
    name: "",
    description: "",
    image: null,
};

function AddCategoryModal({ isOpen, onClose, onSubmit }) {
    const [form, setForm] = useState(DEFAULT_FORM);
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState("");
    const [previewUrl, setPreviewUrl] = useState(null);

    // reset όταν ανοίγει/κλείνει
    useEffect(() => {
        if (!isOpen) {
            setForm(DEFAULT_FORM);
            setSaving(false);
            setErr("");
        }
    }, [isOpen]);

    useEffect(() => {
        if (!form.image) {
            setPreviewUrl(null);
            return undefined;
        }

        const objectUrl = URL.createObjectURL(form.image);
        setPreviewUrl(objectUrl);

        return () => URL.revokeObjectURL(objectUrl);
    }, [form.image]);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setErr("");

        try {
            await onSubmit(form);
            onClose();
        } catch (error) {
            setErr(error?.message || "Create category failed");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
            onMouseDown={(e) => {
                if (e.target === e.currentTarget) onClose(); // click outside
            }}
        >
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4">
                <div className="flex justify-between items-center p-6 border-b">
                    <h2 className="text-2xl font-serif font-bold text-custom-green">
                        Add New Category
                    </h2>
                    <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <i className="fa-solid fa-times text-2xl"></i>
                    </button>
                </div>

                <div className="p-6">
                    <form className="space-y-6" onSubmit={handleSubmit}>
                        {err && (
                            <div className="rounded border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                                {err}
                            </div>
                        )}

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Category Name
                            </label>
                            <input
                                type="text"
                                placeholder="e.g., Round Baskets"
                                value={form.name}
                                onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
                                disabled={saving}
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Description
                            </label>
                            <textarea
                                rows="3"
                                placeholder="Brief description of the category"
                                value={form.description}
                                onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
                                disabled={saving}
                                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Category Image
                            </label>
                            <input
                                type="file"
                                accept="image/png,image/jpeg"
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, image: e.target.files?.[0] ?? null }))
                                }
                                disabled={saving}
                                className="w-full"
                            />
                            <p className="text-sm text-gray-400 mt-2">PNG, JPG up to 5MB</p>

                            {previewUrl && (
                                <div className="mt-3">
                                    <img src={previewUrl} alt="Selected category" className="h-32 w-32 rounded-lg object-cover border" />
                                </div>
                            )}
                        </div>



                        <div className="flex gap-3 pt-4">
                            <button
                                type="button"
                                onClick={onClose}
                                disabled={saving}
                                className="flex-1 px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 font-medium"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={saving}
                                className="flex-1 px-6 py-3 bg-custom-green text-white rounded-lg hover:bg-opacity-90 font-medium"
                            >
                                {saving ? "Creating..." : "Create Category"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddCategoryModal;
